import moment from 'moment';

import { setLoggedUserData } from 'containers/GlobalWrapper/actions';
import { changeLocale } from 'containers/LanguageProvider/actions';
import { api } from 'redux/api/index.api';
import { getUserInfosServiceVersion } from 'utils/constants';
import localStorageUser from 'utils/localStorageUser';

export const userInfosApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchUserInfo: builder.query({
      query: ({ userId }) => ({
        url: `${getUserInfosServiceVersion()}/user-infos/${userId}`,
        method: 'GET',
      }),
      async onQueryStarted(_userId, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          // Handle locale synchronization
          const { locale } = data;
          const locale_language = localStorageUser.getLanguageUserFromLocalStorage();
          if (locale?.length > 0 && locale !== locale_language) {
            moment.locale(locale);
            dispatch(changeLocale(locale));
          }

          // Update logged user data in Redux
          dispatch(setLoggedUserData(data));
        } catch (err) {
          console.error('Failed to fetch user info:', err);
        }
      },
    }),
    fetchUsersList: builder.query({
      query: ({ userIds }) => ({
        url: `${getUserInfosServiceVersion()}/user-infos/list`,
        method: 'POST',
        body: {
          user_ids: [...new Set(userIds)],
        },
      }),
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchUserInfoQuery,
  useLazyFetchUserInfoQuery,
  useFetchUsersListQuery,
  useLazyFetchUsersListQuery,
} = userInfosApi;
